import React from "react";

const CardImage = ({ src }) => {
    return (
        <>
            <div className="card-image">
                <img className="img-" src={src}/>
            </div>
        </>
    );
}

export default CardImage;